<template>
 <h1>mails</h1>
</template>

<script>

export default {
	name: 'mails'
}

</script>
